import React from "react";
import usePageContent from "../hooks/usePageContent";

// Preserve the page-specific hero layout and styling. CMS should only be able to
// swap the background media if configured; it should never replace the custom CSS
// block that defines each page hero's visual design.
export default function CmsPageHero({ slug, children }) {
  const content = usePageContent(slug);
  const image = content?.imageUrl?.[0];
  const video = content?.videoUrl?.[0];

  if (!content || (!image && !video)) return children;

  return (
    <div className="relative isolate overflow-hidden">
      {image && <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />}
      {video && <video src={video} autoPlay loop muted playsInline className="absolute inset-0 h-full w-full object-cover" />}
      {(image || video) && <div className="absolute inset-0 bg-[#151642]/10" />}
      <div className="relative z-10">{children}</div>
    </div>
  );
}
